import PreviewModalGeneric from './PreviewModalGeneric'
export default PreviewModalGeneric
